import React from "react";
import CoinGeckoMarquee from "../components/CoinMarquee";
import Hero from "../components/Hero";
import Features from "../components/Features";
import OurPlans from "../components/OurPlans";
import TradingViewWidget from "../components/TradingViewWidget";
const Home = () => {
  return (
    <div className="">
      <div className="z-50 fixed">
        <CoinGeckoMarquee />
      </div>
      <Hero />
      <div className="bg-secondary-500">
        <Features />
      </div>
      <div className="bg-primary-950">
        <OurPlans />
      </div>
      <div className="h-500px">
        <TradingViewWidget />
      </div>
    </div>
  );
};

export default Home;
